import { createSelector } from 'reselect';

import { ResponseSubscriptionType } from '@r1-frontend/api-domru/api-tariffs/v1/tariffs/[salePackageId]/subscriptions';

import { TSubscription } from '~/src/features/full-buy/store/initialState';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TState } from '~/src/store';

/**
 * Получение обязательных и доступных для выбора (не выбранных!)
 */
export const getRequiredAndSelectivelySubscriptions = createSelector(
    [
        (state: TState) => state.fullBuy,
        selectCurrentTariff,
    ],
    ({ subscriptions, selectedSubscriptions }, tariff) => {
        if (tariff && subscriptions && tariff.sale_package_id in subscriptions) {
            const needToSelect = Number(tariff?.subscriptionsSummary?.find(s => tariff.speed === s.speed)?.cnt || 1);
            const needToSelectMultiple = needToSelect - 1;

            let isOneOfSelected = false;

            const sbs = subscriptions[tariff.sale_package_id].items
                .reduce<{ oneOf: TSubscription[], multiple: TSubscription[] }>(
                    (acc, cur) => {
                        if (cur.type === ResponseSubscriptionType.oneOf) {
                            acc.oneOf.push(cur);
                            if (selectedSubscriptions.includes(cur.serviceId)) {
                                isOneOfSelected = true;
                            }
                        } else {
                            acc.multiple.push(cur);
                        }

                        return acc;
                    }, { oneOf: [], multiple: [] },
                );

            const leftToSelect = needToSelectMultiple - (isOneOfSelected ? selectedSubscriptions.length - 1 : selectedSubscriptions.length);

            return {
                subscriptions: sbs,
                selected: selectedSubscriptions,
                needToSelect: { oneOf: 1, multiple: needToSelectMultiple },
                leftToSelect: { oneOf: isOneOfSelected ? 0 : 1, multiple: leftToSelect },
                tariffName: tariff.tariff_name,
            };
        } else {
            return {
                subscriptions: { oneOf: [], multiple: [] },
                selected: [],
                needToSelect: { oneOf: 0, multiple: 0 },
                leftToSelect: { oneOf: 0, multiple: 0 },
                tariffName: '',
            };
        }
    },
);
